import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { GenericPost } from '@/_shared/types';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_PATH_KEY } from '@/swagger/constants/slash-keys';
import { API_POST_ORGANIZATION_CONFIG, KEY_POST_ORGANIZATION_CONFIG } from '../constants';
import { getCurrentOrganization } from '../selectors';

type ResponsePostAspect = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_PATH_KEY
>['response']['body'];

export type CallParamsPostOrganizationConfig = {
  successSaga?: CallbackSaga<
    object,
    CallResponsePostOrganizationConfig,
    CallErrorPostOrganizationConfig,
    CallSelectorsPostOrganizationConfig
  >;
  errorSaga?: CallbackSaga;
};

type CallResponsePostOrganizationConfig = ResponsePostAspect;

type CallErrorPostOrganizationConfig = {
  message: string;
  code: number;
};

type CallSelectorsPostOrganizationConfig = unknown;

const responseMapper = () => ({
  status: 'OK',
});

export const postOrganizationConfigCall = createGeneralCall<
  CallParamsPostOrganizationConfig,
  CallResponsePostOrganizationConfig,
  CallErrorPostOrganizationConfig,
  CallSelectorsPostOrganizationConfig
>({
  id: KEY_POST_ORGANIZATION_CONFIG,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_POST_ORGANIZATION_CONFIG(org as unknown as string);
  },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        ...payload,
      };
    },
  responseMapper,
});
